import React, { useState, useEffect } from 'react';
import '../styles/research.css'; // Reuse research.css for styling
import '../styles/navbar.css'; // Reuse navbar.css for sidebar
import Papa from 'papaparse';

const FutureVolunteers = () => {
    const [volunteersData, setVolunteersData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const rowsPerPage = 50;

    // Fetch data from Google Sheets (CSV)
    const fetchData = async () => {
        try {
            const csvURL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQZAMagACXZFLNVuPpOHF6OV-bHVPFzcmuYNRfnGiO0jydEA8YrmFm3Jfhb-zzcQWSd5jkzjZ7dTuXx/pub?output=csv";
            const response = await fetch(csvURL);
            const text = await response.text();

            Papa.parse(text, {
                header: true,
                dynamicTyping: true,
                complete: (result) => {
                    const formattedData = result.data.map((row, index) => ({
                        id: index + 1,
                        fullName: row['full_name'] || '',
                        email: row['email'] || '',
                        phone: row['phone'] || '',
                        dob: row['dob'] || '',
                        education: row['education'] || '',
                        opportunities: row['volunteering_opportunities'] || '',
                        comments: row['comments'] || '',
                    }));
                    setVolunteersData(formattedData);
                    setFilteredData(formattedData);
                },
                error: (error) => {
                    console.error('Error parsing CSV:', error);
                    showAlertMessage('Failed to parse volunteers data. Please try again.');
                },
            });
        } catch (error) {
            console.error('Error fetching data:', error);
            showAlertMessage('Failed to fetch volunteers data. Please try again.');
        }
    };

    // Initial fetch
    useEffect(() => {
        fetchData();
    }, []);

    // Handle search
    useEffect(() => {
        const filtered = volunteersData.filter((row) => {
            return (
                row.fullName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                row.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                row.phone?.toString().includes(searchQuery)
            );
        });
        setFilteredData(filtered);
        setCurrentPage(1);
    }, [searchQuery, volunteersData]);

    // Pagination logic
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Show alert message
    const showAlertMessage = (message) => {
        setAlertMessage(message);
        setShowAlert(true);
        setTimeout(() => {
            setShowAlert(false);
        }, 3000);
    };

    // Toggle sidebar state
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    // Handle logout
    const handleLogout = () => {
        window.location.href = '/';
    };

    return (
        <div className="dashboard-container">
            <div className="particles">
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
            </div>
            <aside className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="sidebar-header">
                    <h1 className="logo" data-text="Innovathrive">Innovathrive</h1>
                    <button onClick={toggleSidebar} className="toggle-button">
                        {isSidebarOpen ? (
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00f7ff" strokeWidth="2">
                                <path d="M15 18l-6-6 6-6" />
                            </svg>
                        ) : (
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00f7ff" strokeWidth="2">
                                <path d="M9 18l6-6-6-6" />
                            </svg>
                        )}
                    </button>
                </div>
                <nav id="nav-bar">
                    <div className="nav-particles">
                        <div className="nav-particle"></div>
                        <div className="nav-particle"></div>
                        <div className="nav-particle"></div>
                    </div>
                    <div id="nav-header">
                        <a id="nav-title" href="/dashboard" data-text="Future Volunteers">Future Volunteers</a>
                        <hr />
                    </div>
                    <div id="nav-content">
                        <div className={`nav-button ${window.location.pathname === '/dashboard' ? 'active' : ''}`}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00f7ff" strokeWidth="2">
                                <path d="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z" />
                            </svg>
                            <a href="/dashboard" data-text="Dashboard">Dashboard</a>
                        </div>
                        <div className={`nav-button ${window.location.pathname === '/research' ? 'active' : ''}`}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00f7ff" strokeWidth="2">
                                <circle cx="11" cy="11" r="8" />
                                <line x1="21" y1="21" x2="16.65" y2="16.65" />
                            </svg>
                            <a href="/research" data-text="Research Reviewing Committee">Research</a>
                        </div>
                        <div className={`nav-button ${window.location.pathname === '/volunteers' ? 'active' : ''}`}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00f7ff" strokeWidth="2">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                            </svg>
                            <a href="/volunteers" data-text="Volunteers Board">Volunteers Board</a>
                        </div>
                        <div className={`nav-button ${window.location.pathname === '/future-volunteers' ? 'active' : ''}`}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00f7ff" strokeWidth="2">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                <circle cx="8.5" cy="7" r="4" />
                                <path d="M20 8v6M23 11h-6" />
                            </svg>
                            <a href="/future-volunteers" data-text="Future Volunteers">Future Volunteers</a>
                        </div>
                        <div className={`nav-button ${window.location.pathname === '/USAID' ? 'active' : ''}`}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00f7ff" strokeWidth="2">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                            </svg>
                            <a href="/USAID" data-text="USAID">USAID</a>
                        </div>
                        <hr />
                    </div>
                </nav>
            </aside>
            <main className="main-content">
                <header className="dashboard-header">
                    <div className="header-title">
                        <h2 data-text="Future Volunteers">Future Volunteers</h2>
                    </div>
                    <div className="header-actions">
                        <div className="search-bar">
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Search by name, email, or phone..."
                            />
                            <span className="search-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#00f7ff" strokeWidth="2">
                                    <circle cx="11" cy="11" r="8" />
                                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                                </svg>
                            </span>
                        </div>
                        <button onClick={fetchData} className="refresh-button">
                            <span className="refresh-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#00f7ff" strokeWidth="2">
                                    <path d="M23 4v6h-6M1 20v-6h6" />
                                    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
                                </svg>
                            </span>
                            Refresh
                        </button>
                        <button onClick={handleLogout} className="logout-button">Logout</button>
                    </div>
                </header>
                <section className="dashboard-widgets">
                    <table className="research-table">
                        <thead>
                            <tr>
                                <th>Full Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Date of Birth</th>
                                <th>Education</th>
                                <th>Opportunities</th>
                                <th>Comments</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRows.map((row) => (
                                <tr key={row.id}>
                                    <td>{row.fullName}</td>
                                    <td>{row.email}</td>
                                    <td>{row.phone}</td>
                                    <td>{row.dob}</td>
                                    <td>{row.education}</td>
                                    <td>{row.opportunities}</td>
                                    <td>{row.comments}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </section>
                <div className="pagination">
                    {Array.from({ length: Math.ceil(filteredData.length / rowsPerPage) }, (_, i) => (
                        <button
                            key={i + 1}
                            onClick={() => handlePageChange(i + 1)}
                            className={currentPage === i + 1 ? 'active' : ''}
                        >
                            {i + 1}
                        </button>
                    ))}
                </div>
                {showAlert && <div className="alert">{alertMessage}</div>}
            </main>
        </div>
    );
};

export default FutureVolunteers;